// Cuándo mostrar una versión nueva de la app (PWA). Con skipWaiting +
// clientsClaim (workbox-config.js), el service worker nuevo toma el control de
// las pestañas abiertas en cuanto se instala (`controllerchange`), pero la
// página sigue corriendo el JS viejo hasta recargar. Sin esto había que abrir
// la app dos veces para ver cada actualización.
//
// - Si la versión nueva llega apenas se abrió la app (VENTANA_RECARGA_MS), se
//   recarga sola: todavía no hay nada a medias.
// - Si llega con la app en uso, NO se recarga (el POS no guarda el carrito):
//   se avisa con EVENTO_NUEVA_VERSION y NuevaVersionBanner ofrece actualizar.
// - La primera instalación del service worker también dispara controllerchange,
//   pero no es una versión nueva: se ignora si la página no tenía controlador.

export const VENTANA_RECARGA_MS = 10 * 1000;
export const EVENTO_NUEVA_VERSION = 'vendita:nueva-version';

let versionNuevaPendiente = false;
export const hayVersionNueva = () => versionNuevaPendiente;

export function vigilarActualizaciones({
  sw = navigator.serviceWorker,
  recargar = () => window.location.reload(),
  ahora = () => Date.now(),
  cargadaEn = Date.now(),
} = {}) {
  const habiaControlador = Boolean(sw.controller);
  let recargando = false;

  sw.addEventListener('controllerchange', () => {
    if (!habiaControlador || recargando) return;
    if (ahora() - cargadaEn < VENTANA_RECARGA_MS) {
      recargando = true;
      recargar();
      return;
    }
    versionNuevaPendiente = true;
    window.dispatchEvent(new Event(EVENTO_NUEVA_VERSION));
  });
}

// Solo para pruebas.
export const reiniciarActualizacionSw = () => {
  versionNuevaPendiente = false;
};
